import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg'
import { ReactComponent as IconInformation } from '@/assets/svgs/DesignSystem/DS_Icon_info.svg'
import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg'
import Button from '@/components/Button'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import DatePicker from '@/components/DatePicker/index'
import MultiSelectCheckbox from '@/components/MultiSelectCheckbox/index'
import Tabs, { Tab } from '@/components/Tabs'
import Toast2 from '@/components/Toast2'
import useAudit from '@/hooks/use-audit'
import useConfig from '@/hooks/use-config'
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page'
import getPageLabel from '@/hooks/use-page-details/index'
import { useNavigate } from '@/lib/router-dom'
import API_AUDIT from '@/services/api/audit.js'
import "@/translations/i18n"
import { produce } from 'immer'
import { orderBy, uniqBy } from 'lodash'
import moment from 'moment'
import { Fragment, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from "react-i18next"
import KeyboardEventHandler from '@infinium/react-keyboard-event-handler'
import MultiClamp from 'react-multi-clamp'
import Tags from '@/componentsDS/Tags/Tags';
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index'
import { feature, features } from '@/utils/feature-verifier';
import PropTypes from 'prop-types';
import { featureConstant } from "@/constants/configuration/feature.js";
import { useFeature } from "@/hooks/use-feature/index.js";
import { renderUserEmailInline, renderUserEmailStacked } from '@/utils/formatUserEmail';

function statusTag(status) {
	const statusText = status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
	return (
		<>
			{status === "SUCCESS" && <Tags label={statusText} tagClassName="DS__tag--success" />}
			{(status === "FAIL" || status === "ERROR") && <Tags label={statusText} tagClassName="DS__tag--critical" />}
		</>
	)
}
export const AuditLogEntry = ({ audit }) => {
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);

	return (
		<div className="audit-trail-container--left audit-trail-container--layout">
			<div>{isSoftDeleteUserEnabled ? renderUserEmailInline(audit?.userId) : audit?.userId}</div>
			<div>{audit?.event}</div>
			<div>{audit?.message}</div>
			{audit?.data?.participants?.[0]?.name && <div>{audit?.data?.participants?.[0]?.name}</div>}
			{audit?.data?.elementName && <div>{audit?.data?.elementName}</div>}
			<div>{audit?.via}</div>
			<div>{statusTag(audit?.status)}</div>
			<div>{moment(audit?.timestamp).format('DD/MM/YYYY h:mmA')}</div>
		</div>
	);
};

AuditLogEntry.propTypes = {
	audit: PropTypes.shape({
		userId: PropTypes.string,
		event: PropTypes.string,
		message: PropTypes.string,
		via: PropTypes.string,
		status: PropTypes.string,
		timestamp: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
			PropTypes.instanceOf(Date),
		]),
		data: PropTypes.shape({
			elementName: PropTypes.string,
			participants: PropTypes.arrayOf(
				PropTypes.shape({
					name: PropTypes.string,
				})
			),
		}),
	})
};

const Page = () => {

	/*=================================================
		General
	/================================================*/
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);
	const { t } = useTranslation();
	const [pageTitle, setPageTitle] = useState(t("myActivities"))

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'My Activities',
				link: `/my-activities`
			},
		]
	})
	const { goTo } = useNavigate();

	const pageLimit = 10

	/*=================================================
		Error Modal
	/================================================*/
	const [error, setError] = useState()
	function handleError() {
		setError()
	}

	/*=================================================
		Options
	/================================================*/

	const [fileType, setFileType] = useState('csv')

	/*=================================================
		API
	/================================================*/

	// const getAuditAPIParams = {
	// 	page: currentPage,
	// 	limit: pageLimit,
	// }
	const [loading, setloading] = useState(true);

	const { config, consumeItems, consumeSystems, provideItems, provideSystems, error: errorConfig } = useConfig()
	const { items: auditItems, fetch: fetchAudits, setItems: setAudits, find: findDownloadAudits, meta: auditMeta, setCurrentItem: setAudit, currentItem: currentAudit, getAuditEnum, error: errorAudit } = useAudit()

	useEffect(() => {
		// fetchAudits(getAuditAPIParams)
		getAuditEnum().then(
			value => {
				setSelectTypeOptions(value.type)
				setSelectedDataEventValues(sortArray(value.event.filter(item => item.type.toLowerCase() === "data_exchange")))
				setSelectedUserEventValues(sortArray(value.event.filter(item => item.type.toLowerCase() === "user_activity")))
				setSelectedSystemEventValues(sortArray(value.event.filter(item => item.type.toLowerCase() === "system")))
				setSelectedViaValues(sortArray(value.via))
				setSelectedStatusValues(sortArray(value.status))

				setSelectTypeValue(value.type[0].id)
				// fetchAuditHandler(value.type[0].id)
			}
		).catch(
			value => {
				setError(value?.error?.message)
			}
		);
		fetchAuditHandler()
	}, []);

	useEffect(() => {
		setloading(true);
		setTimeout(() => {
			setloading(false)
		}, 2000);
	}, [auditItems])

	// const [newParameter, setNewParameter] = useState(getAuditAPIParams);

	useEffect(() => {
		setError(errorConfig)
		setError(errorAudit)
	}, [errorConfig, errorAudit])

	function fetchAuditHandler(value = null) {
		setloading(true);
		let eventSelected = null
		const userEvent = convertArrayToString(selectedUserEventValues)
		const dataEvent = convertArrayToString(selectedDataEventValues)
		const systemEvent = convertArrayToString(selectedSystemEventValues)

		if (userEvent !== null) {
			eventSelected = userEvent
		}

		if (dataEvent !== null) {
			eventSelected = dataEvent
		}

		if (systemEvent !== null) {
			eventSelected = systemEvent
		}
		if (currentPage) {

			fetchAudits({
				page: currentPage,
				limit: pageLimit,
				dateFrom: startDate !== null ? moment(startDate).format('yyyy-MM-DD HH:mm') : null,
				dateTo: endDate !== null ? moment(endDate).format('yyyy-MM-DD HH:mm') : null,
				type: selectTypeValue ?? value,
				event: eventSelected ?? null,
				// orgId: selectedParticipantsValues ? convertArrayToString(selectedParticipantsValues) : null,
				orgId: convertArrayToString(participantsOptions) ?? null,
				via: convertArrayToString(selectedViaValues) ?? null,
				dataElementId: convertArrayToString(dataElementsOptions) ?? null,
				status: convertArrayToString(selectedStatusValues) ?? null
			})
		}
		setloading(false)

	}

	/*=================================================
		Modal
	/================================================*/

	const { visible: detailVisible, show: detailShow, hide: detailHide } = useModal()

	/*=================================================
		Tabs
	/================================================*/
	function selectTab(item) {
		if (!selectTypeOptions || !Array.isArray(selectTypeOptions)) {
			throw Error('type options does not exist');
		}

		const index = selectTypeOptions.findIndex(option => option.id === item.id)
		const tabs = [...selectTypeOptions].map(item => ({ ...item, $selected: false }))

		handleTabChange(item.id)
		setSelectTypeOptions(tabs)

		resetFilter()
		tabs[index].$selected = true

		setSelectTypeValue(item.id);
	}

	/*=================================================
		Options
	/================================================*/

	//Date
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	useEffect(() => {
		return setEndDate(null);
	}, [startDate]);

	function handleTabChange(item) {
		setSelectTypeValue(item.id)
		setFalse(selectedUserEventValues, setSelectedUserEventValues)
		setFalse(selectedDataEventValues, setSelectedDataEventValues)
		setFalse(selectedSystemEventValues, setSelectedSystemEventValues)
		setFalse(selectedViaValues, setSelectedViaValues)
		setFalse(selectedStatusValues, setSelectedStatusValues)
		setFalse(participantsOptions, setParticipantsOptions)
		setFalse(dataElementsOptions, setDataElementsOptions)


		// setSelectTypeValue(item.id)
		// if (item?.id !== selectTypeValue){
		// 	if (selectTypeValue.toLowerCase() === "data_exchange"){
		// 		setFalse(selectedUserEventValues, setSelectedUserEventValues)
		// 	}
		// 	if (selectTypeValue.toLowerCase() === "user_activity"){
		// 		setFalse(selectedDataEventValues, setSelectedDataEventValues)
		// 	}
		// 	if (selectTypeValue.toLowerCase() === "system"){
		// 		setFalse(selectedSystemEventValues, setSelectedSystemEventValues)
		// 	}
		// 	setFalse(selectedViaValues,setSelectedViaValues)
		// 	setFalse(selectedStatusValues,setSelectedStatusValues)
		// 	setFalse(participantsOptions,setParticipantsOptions)
		// 	setFalse(dataElementsOptions,setDataElementsOptions)
		// }
	}

	//Type
	const [selectTypeOptions, setSelectTypeOptions] = useState()
	const [selectTypeValue, setSelectTypeValue] = useState(null)

	//Event - Data Exchange
	const [selectedDataEventValues, setSelectedDataEventValues] = useState();

	//Event - User Activity
	const [selectedUserEventValues, setSelectedUserEventValues] = useState();

	//Event - System
	const [selectedSystemEventValues, setSelectedSystemEventValues] = useState();

	//Via
	const [selectedViaValues, setSelectedViaValues] = useState();

	//Status
	const [selectedStatusValues, setSelectedStatusValues] = useState();

	//Destination
	const [participantsOptions, setParticipantsOptions] = useState([])

	useEffect(() => {

		const consumeOptions = consumeSystems.map(item => ({ id: item.id, name: item.name }))
		const provideOptions = provideSystems.map(item => ({ id: item.id, name: item.name }))

		const combineOptions = [...consumeOptions, ...provideOptions]
		const updatedOptions = uniqBy(combineOptions, "id");

		setParticipantsOptions(sortArray(updatedOptions))

	}, [consumeSystems, provideSystems])

	//Data Element
	const [dataElementsOptions, setDataElementsOptions] = useState([])

	useEffect(() => {

		const consumeOptions = consumeItems.map(item => ({ id: item.id, name: item.name }))
		const provideOptions = provideItems.map(item => ({ id: item.id, name: item.name }))

		const combineOptions = [...consumeOptions, ...provideOptions]
		const updatedOptions = uniqBy(combineOptions, "id");

		setDataElementsOptions(sortArray(updatedOptions))

	}, [config])

	/*=================================================
		Sort
	/================================================*/

	function retrieveIdfromMessages(array) {
		const tempArray = [];

		array.forEach(item => {
			if (item.$selected) {
				tempArray.push(item.id)
			}
		})

		return tempArray
	}

	async function downloadFile() {
		let eventSelected = null
		const userEvent = convertArrayToString(selectedUserEventValues)
		const dataEvent = convertArrayToString(selectedDataEventValues)
		const systemEvent = convertArrayToString(selectedSystemEventValues)

		if (userEvent !== null) {
			eventSelected = userEvent
		}

		if (dataEvent !== null) {
			eventSelected = dataEvent
		}

		if (systemEvent !== null) {
			eventSelected = systemEvent
		}

		const tempArray = retrieveIdfromMessages(auditItems.filter(message => message.$selected));
		const [error, result] = await API_AUDIT.exportAuditData({
			id: tempArray,
		}, fileType, {
			params: {
				dateFrom: startDate !== null ? moment(startDate).format('yyyy-MM-DD HH:mm') : null,
				dateTo: endDate !== null ? moment(endDate).format('yyyy-MM-DD HH:mm') : null,
				type: selectTypeValue,
				event: eventSelected ?? null,
				// orgId: selectedParticipantsValues ? convertArrayToString(selectedParticipantsValues) : null,
				orgId: convertArrayToString(participantsOptions) ?? null,
				via: convertArrayToString(selectedViaValues) ?? null,
				dataElementId: convertArrayToString(dataElementsOptions) ?? null,
				status: convertArrayToString(selectedStatusValues) ?? null
			}
		})

		if (error) {
			return setError(error?.error?.message || "Unable to retrieve Config")
		}

		const link = document.createElement("a")
		const path = `data:text/csv;charset=utf-8,%EF%BB%BF${result}`
		link.href = path;
		link.download = "attachment.csv";
		link.click();

	}

	/*=================================================
		Paginate
	/================================================*/
	// const { displayedPages } = usePagination({ total: auditMeta?.totalPages, current: currentPage, max: 5 })

	// useEffect(() => {
	// 	const tempNewParameter = {
	// 		...newParameter,
	// 		page: currentPage,
	// 	}

	// 	const cleanObject = pickBy(tempNewParameter, identity)
	// 	fetchAudits(cleanObject)
	// }, [currentPage])

	// function goToPrev() {

	// 	if (currentPage === 1) {
	// 		return
	// 	}

	// 	setCurrentPage(prev => prev - 1)
	// }

	// function goToNext() {
	// 	if (currentPage === auditMeta.totalPages) {
	// 		return
	// 	}

	// 	setCurrentPage(prev => prev + 1)
	// }
	const [currentPage, setCurrentPage] = useState(1)

	useEffect(() => {
		if (!loading)
			fetchAuditHandler()
	}, [currentPage, selectTypeValue, startDate, endDate, selectedDataEventValues, selectedUserEventValues, selectedSystemEventValues, selectedViaValues, selectedStatusValues, participantsOptions, dataElementsOptions])

	function goToPrev() {

		if (currentPage === 1) {
			return
		}

		setCurrentPage(prev => prev - 1)
	}

	function goToNext() {
		if (currentPage === auditMeta?.totalPages) {
			return
		}

		setCurrentPage(prev => prev + 1)
	}

	useEffect(() => {
		if (currentPage > auditMeta?.totalPages) {
			setCurrentPage(auditMeta?.totalPages || 1)
		}
	}, [auditItems])

	/*=================================================
		Data Table
	/================================================*/

	let timeout

	function handleCurrentInput(e) {
		const value = e.target?.value
		const current = parseInt(value)

		clearTimeout(timeout)

		timeout = setTimeout(() => {
			if (current > auditMeta.totalPages) {
				return setCurrentPage(auditMeta.totalPages)
			}

			if (isNaN(current)) {
				setError("Invalid page number")
			}

			setCurrentPage(current)
		})
	}

	const DataTable = ({ itemData, title }) => {
		function changeListCheckboxes(event) {
			const index = itemData.findIndex(field => field.id === parseInt(event.target.value))
			const updatedItem = produce(itemData, draft => {
				draft[index].$selected = !draft[index].$selected
			})
			setAudits(updatedItem)
		}
		function changeAllListCheckboxes(event) {
			if (event.target.checked) {
				const updatedItem = auditItems.map(field => ({ ...field, $selected: true }))
				return setAudits(updatedItem)
			}

			const updatedItem = auditItems.map(field => ({ ...field, $selected: false }))
			setAudits(updatedItem)
		}

		function isAllChecked() {
			return itemData.every(field => field.$selected)
		}

		const list = itemData.map((item, index) => {
			return (
				<div className="data-table__table__body__row" key={index}>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{moment(item.timestamp).format('DD/MM/YYYY h:mma')}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__table__body__content--break">
						{item.event}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break soft-delete__tooltip-container">
						{isSoftDeleteUserEnabled ? renderUserEmailStacked(item.userId) : item.userId}
						{isSoftDeleteUserEnabled && item?.userId?.user_status === 'DELETED' && <div className="tooltiptexts eform-tooltip-text">{renderUserEmailStacked(item?.userId)}</div>}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text">
						{statusTag(item.status.toUpperCase())}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text">
						<MultiClamp clamp={3}>{item.message}</MultiClamp>
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--end tooltip">
						<span className="data-table__table__body__content__action link"
							onClick={() => {
								handleView(item.id)
							}}
						>
							<span className="tooltiptext" style={{ marginLeft: -75 }}>View Details</span>
							<IconChevronRight />
						</span>
					</div>
				</div>
			)
		})

		const NoMessage = () => {
			return (
				<div className="data-table__empty__icon">
					<IconNoMessage />
					<span>No audit trail found</span>
				</div>
			)
		}

		return (
			<div className="data-table__content">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row">
									<div className="data-table__table__head__row__left">
										{title}
									</div>
									<div className="data-table__table__head__row__right">
										<Button text="Export"
											full
											submit={() => {
												downloadFile();
											}}
										/>
									</div>
								</div>
								<div className="data-table__table__head__row">
									<div className="data-table__table__head__title">
										Date/Time
									</div>
									<div className="data-table__table__head__title">
										Event
									</div>
									<div className="data-table__table__head__title">
										User
									</div>
									<div className="data-table__table__head__title">
										Status
									</div>
									<div className="data-table__table__head__title" >
										Messages
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--end"></div>
								</div>
							</div>
							<div className="data-table__table__body">
								{list.length > 0 ?
									list :
									<div className="data-table__empty"><NoMessage /></div>
								}
							</div>
							{
								list.length > 0 && (
									<div className="data-table__table__footer">
										<div className="data-table__table__footer__row">
											<div className="data-table__table__footer__row__left">
												<div className="data-table__table__pagination">
													<input className="data-table__table__pagination__page" type="number" value={currentPage} onChange={(e) => handleCurrentInput(e)} min="1" />
													<span className="data-table__table__pagination__page__meta"> of {auditMeta?.totalPages || 1} pages </span>
													<button className="data-table__table__pagination__prev" onClick={() => goToPrev()} disabled={currentPage === 1}><IconChevronDown /></button>
													<button className="data-table__table__pagination__next" onClick={() => goToNext()} disabled={currentPage === auditMeta?.totalPages}><IconChevronDown /></button>
												</div>
											</div>
											<div className="data-table__table__footer__row__right">
												<div className="data-table__table__meta">
													Showing {getPageLabel(auditMeta?.total, pageLimit, currentPage - 1)} of {auditMeta?.total || 0} entries
												</div>
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	/*=================================================
		Functions
	/================================================*/


	// function handleSubmit() {

	// 	let eventSelected = ""
	// 	const userEvent = convertArrayToString(selectedUserEventValues)
	// 	const dataEvent = convertArrayToString(selectedDataEventValues)

	// 	if (userEvent !== null){
	// 		eventSelected = userEvent
	// 	}

	// 	if (dataEvent !== null){
	// 		eventSelected = dataEvent
	// 	}

	// 	const tempNewParameter = {
	// 		...newParameter,
	// 		dateFrom: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
	// 		dateTo: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
	// 		type: selectTypeValue ? selectTypeValue : null,
	// 		event: eventSelected,
	// 		// orgId: selectedParticipantsValues ? convertArrayToString(selectedParticipantsValues) : null,
	// 		destination: participantsOptions ? convertArrayToString(participantsOptions) : null,
	// 		via: selectedViaValues ? convertArrayToString(selectedViaValues) : null,
	// 		dataElementId: dataElementsOptions ? convertArrayToString(dataElementsOptions) : null,
	// 		status: selectedStatusValues ? convertArrayToString(selectedStatusValues) : null
	// 	}

	// 	setCurrentPage(1);

	// 	const cleanObject = pickBy(tempNewParameter, identity)
	// 	setNewParameter(cleanObject)

	// 	fetchAudits(cleanObject)

	// 	filterHide()
	// }

	// function handleReset() {
	// 	setStartDate()
	// 	setEndDate()
	// 	setSelectTypeValue()
	// 	setFalse(selectedDataEventValues, setSelectedDataEventValues)
	// 	setFalse(selectedUserEventValues, setSelectedUserEventValues)
	// 	setFalse(selectedViaValues,setSelectedViaValues)
	// 	setFalse(selectedStatusValues,setSelectedStatusValues)
	// 	setFalse(participantsOptions,setParticipantsOptions)
	// 	setFalse(dataElementsOptions,setDataElementsOptions)
	// }

	function handleView(id) {
		async function getData() {
			const [error, result] = await API_AUDIT.findOne(id)
			setAudit(result);

			if (error) {
				return setError(error?.error?.message || "Unable to retrive audit detail")
			}
		}

		getData();
		detailShow();
	}

	// async function getAudit() {
	// 	const {limit, page, ...downloadAuditParameter} = newParameter
	// 	const cleanObject = pickBy(downloadAuditParameter, identity)
	// 	const auditData = await findDownloadAudits(cleanObject)
	// 	return auditData
	// }
	// function handleDownload() {
	// 	getAudit().then(data =>{
	// 		const jsonPath = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(data))}`
	// 		try {
	// 			const link = document.createElement("a");
	// 			link.href = jsonPath;
	// 			link.download = "audit.json";
	// 			document.body.appendChild(link);
	// 			link.click();
	// 		} catch (err) {
	// 			setError(err || "Unable to download audit.json")
	// 		}
	// 	})
	// }

	function sortArray(array) {
		return orderBy(array, [option => option?.name.toLowerCase(), ['asc']])
	}

	function convertArrayToString(array) {

		if (!Array.isArray(array)) {
			return null
		}

		if (array.every(item => item.$selected === true)) {
			return null
		}

		const tempArray = retrieveId(array)

		if (tempArray.length > 0) {
			return tempArray.toString();
		}

		return null
	}

	function retrieveId(array) {
		const tempArray = [];

		array.forEach(item => {
			if (item.$selected) {
				tempArray.push(item.id)
			}
		})

		return tempArray
	}

	function setFalse(array, setArray) {
		const updatedItem = array.map(field => ({ ...field, $selected: false }))
		setArray(updatedItem)
	}

	function resetFilter() {
		setFalse(selectedUserEventValues, setSelectedUserEventValues)
		setFalse(selectedDataEventValues, setSelectedDataEventValues)
		setFalse(selectedSystemEventValues, setSelectedSystemEventValues)
		setFalse(selectedViaValues, setSelectedViaValues)
		setFalse(selectedStatusValues, setSelectedStatusValues)
		setFalse(participantsOptions, setParticipantsOptions)
		setFalse(dataElementsOptions, setDataElementsOptions)

		setStartDate(null)
		setEndDate(null)
	}

	const StartDate = () => {
		return (
			<>
				<div className="overview_filter__col__top overview_filter__col__title">
					Start Date
				</div>
				<div className="overview_filter__col__bottom">
					<DatePicker
						selectDate={startDate}
						setSelectDate={setStartDate}
						placeHolderText="Select date and time"
					/>
				</div>
			</>
		)
	}

	const EndDate = () => {
		return (
			<>
				<div className="overview_filter__col__top">
					End Date
				</div>
				<div className="overview_filter__col__bottom">
					<DatePicker
						selectDate={endDate}
						setSelectDate={setEndDate}
						placeHolderText="Select date and time"
						minDate={new Date(startDate)}
						disable={!startDate}
						minTime={
							((startDate && endDate) ? (((startDate.getDate() === endDate.getDate()) ? new Date(startDate) : new Date().setHours(0, 0, 0))) : new Date(0, 0, 0))
						}
						maxTime={new Date().setHours(23, 59, 59)}
					/>
				</div>
			</>
		)
	}

	const EventContent = () => {
		return (
			<>
				<div className="overview_filter__col__top overview_filter__col__title">
					Event
				</div>
				<div className="overview_filter__col__bottom">
				{feature(features.NOTIFY_MULTIPLE_ENPOINT) ? (
					<MultiSelectCheckbox items={selectTypeValue === "USER_ACTIVITY" ? selectedUserEventValues : (selectTypeValue === "DATA_EXCHANGE" ? selectedDataEventValues : selectedSystemEventValues)} onChangeFunc={selectTypeValue === "USER_ACTIVITY" ? setSelectedUserEventValues : (selectTypeValue === "DATA_EXCHANGE" ? setSelectedDataEventValues : setSelectedSystemEventValues)} />
					) : (
					<MultiSelectCheckbox items={selectedUserEventValues} onChangeFunc={setSelectedUserEventValues} />
				)}
				</div>
			</>
		)
	}

	const ClearFilters = () => {
		return (
			<>
				<div className="overview_filter__col__top">
					&nbsp;
				</div>
				<div className="overview_filter__col__bottom overview_filter__col__title--heavy overview_filter__col__bottom--padding-top-bottom">
					<span className="link link--color" onClick={() => resetFilter()}>Clear filters</span>
				</div>
			</>
		)
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{pageTitle}
					</div>
				</div>
				<div className="title-header__right">
					{/* <Button prefix={<IconDownloadCloud />} ghost full maxWidth={140} text={t("download")} submit={() => handleDownload()} /> */}
				</div>
			</div>

			<div className="api-configuration__header">
				<Tabs>
					{selectTypeOptions?.map((item, index) => (
						<Tab key={index} label={item.name} active={item.$selected} onClick={() => selectTab(item)} id={'audit-trail-' + item.id.toLowerCase()} />
					))}
				</Tabs>
			</div>

			<div className="title-header__hr">
				<hr />
			</div>

			{/* <div className="overview__filter">
				<div className="overview__filter__left">
					<div className="overview__filter__item">
						<Button prefix={<IconFilter />} border text={t("filter")} submit={() => filterShow()} />
					</div>
				</div>
			</div> */}

			<div className="overview overview--margin-top">
				{
					selectTypeOptions?.map((item, index) => {
						if (item.id.toLowerCase() === "user_activity" && item.$selected === true) {
							return (
								<Fragment key={index}>
									<div className="overview_filter user_activity">
										<div className="overview_filter__cols user_activity">
											<div className="overview_filter__col user_activity">
												<StartDate />
											</div>
											<div className="overview_filter__col user_activity">
												<div className="overview_filter__col__top user_activity">
													&nbsp;
												</div>
												<div className="overview_filter__col__bottom overview_filter__col__bottom--padding-top-bottom user_activity">
													–
												</div>
											</div>
											<div className="overview_filter__col user_activity user_activity">
												<EndDate />
											</div>
											<div className="overview_filter__col user_activity">
												<EventContent />
											</div>
											<div className="overview_filter__col user_activity">
												<div className="overview_filter__col__top user_activity">
													Status
												</div>
												<div className="overview_filter__col__bottom user_activity">
													<MultiSelectCheckbox items={selectedStatusValues} onChangeFunc={setSelectedStatusValues} />
												</div>
											</div>
											<div className="overview_filter__col user_activity">
												<ClearFilters />
											</div>
										</div>
									</div>
									<div className="overview__content user_activity">
										{DataTable({ itemData: auditItems, title: "User Activities" })}
									</div>
								</Fragment>

							)
						}
						if (item.id.toLowerCase() === "data_exchange" && item.$selected === true) {
							return (
								<Fragment key={index}>
									<div className="overview_filter">
										<div className="overview_filter__cols data_exchange">
											<div className="overview_filter__col data_exchange">
												<StartDate />
											</div>
											<div className="overview_filter__col data_exchange">
												<div className="overview_filter__col__top data_exchange">
													&nbsp;
												</div>
												<div className="overview_filter__col__bottom overview_filter__col__bottom--padding-top-bottom data_exchange">
													–
												</div>
											</div>
											<div className="overview_filter__col data_exchange">
												<EndDate />
											</div>
											<div className="overview_filter__col data_exchange">
												<EventContent />
											</div>
											<div className="overview_filter__col data_exchange">
												<div className="overview_filter__col__top data_exchange">
													Data Element
												</div>
												<div className="overview_filter__col__bottom data_exchange">
													<MultiSelectCheckbox items={dataElementsOptions} onChangeFunc={setDataElementsOptions} />
												</div>
											</div>
											<div className="overview_filter__col data_exchange">
												<div className="overview_filter__col__top overview_filter__col__title">
													Sender / Destination
												</div>
												<div className="overview_filter__col__bottom data_exchange">
													<MultiSelectCheckbox items={participantsOptions} onChangeFunc={setParticipantsOptions} />
												</div>
											</div>
											<div className="overview_filter__col data_exchange">
												<div className="overview_filter__col__top">
													Via
												</div>
												<div className="overview_filter__col__bottom data_exchange">
													<MultiSelectCheckbox items={selectedViaValues} onChangeFunc={setSelectedViaValues} />
												</div>
											</div>
											<div className="overview_filter__col data_exchange">
												<div className="overview_filter__col__top">
													Status
												</div>
												<div className="overview_filter__col__bottom data_exchange">
													<MultiSelectCheckbox items={selectedStatusValues} onChangeFunc={setSelectedStatusValues} />
												</div>
											</div>
											<div className="overview_filter__col data_exchange">
												<ClearFilters />
											</div>
										</div>
									</div>
									<div className="overview__content data_exchange">
										{DataTable({ itemData: auditItems, title: "Data Exchange Activities" })}
									</div>
								</Fragment>
							)
						}
						if (item.id.toLowerCase() === "system" && item.$selected === true) {
							return (
								<Fragment key={index}>
									<div className="overview_filter">
										<div className="overview_filter__cols">
											<div className="overview_filter__col">
												<StartDate />
											</div>
											<div className="overview_filter__col">
												<div className="overview_filter__col__top">
													&nbsp;
												</div>
												<div className="overview_filter__col__bottom overview_filter__col__bottom--padding-top-bottom">
													–
												</div>
											</div>
											<div className="overview_filter__col">
												<EndDate />
											</div>
											<div className="overview_filter__col">
												<EventContent />
											</div>
											<div className="overview_filter__col">
												<ClearFilters />
											</div>
										</div>
									</div>
									<div className="overview__content">
										{DataTable({ itemData: auditItems, titile: "System Activities" })}
									</div>
								</Fragment>
							)
						}

						return null
					})
				}


			</div>

			{/* <div className="overview__content">
				{
					auditItems.length > 0 ? auditItems.map((auditItem, index) => {
						return (
							<div className="message-item" key={index} >
								<div className="message-item__column">
									<div className="message-item__top message-item__text--heading">{t("event")}</div>
									<div className="message-item__bottom message-item__text">{auditItem.event}</div>
								</div>
								<div className="message-item__column">
									<div className="message-item__top message-item__text--heading">{t("message")}</div>
									<div className="message-item__bottom message-item__text">
										<MultiClamp clamp={3}>{auditItem.message}</MultiClamp>
									</div>
								</div>
								<div className="message-item__column">
									<div className="message-item__top message-item__text--heading">{t("date")}</div>
									<div className="message-item__bottom message-item__text">
										{moment(auditItem.timestamp).format('DD/MM/YYYY h:mmA')}
									</div>
								</div>
								<div className="message-item__column message-item__column--small message-item__column--button" >
									<Button full text={t("view")} round submit={() => handleView(auditItem.id)} />
								</div>
							</div>
						)
					})
						: <div style={{
							display: 'flex',
							justifyContent: 'center',
							padding: `${rem(20)}`,
							fontSize: rem(14),
						}}>
							{t("noRecordsFound")}
						</div>
				}
			</div> */}

			{/* <div className="overview__footer">
				{auditMeta && auditMeta.totalPages > 0 && (
					<Pagination value={currentPage}>
						<Pagination.Left onClick={() => goToPrev()}></Pagination.Left>

						{ displayedPages.map((page, index) => {
							return (
								<Pagination.Item key={index} value={page} onClick={() => setCurrentPage(page)}>{page}</Pagination.Item>
							)
						})}

						<Pagination.Right onClick={() => goToNext()}></Pagination.Right>
					</Pagination>
				)}
			</div> */}

			{/* <Modal visible={filterVisible}>
				<KeyboardEventHandler handleKeys={["esc"]} onKeyEvent={(key, e) => {
					filterHide()
				}} />
				<CardConfigure style={{ maxWidth: rem(800), position: 'relative', top: rem(40) }}>
					<CardConfigure.Header>
						<CardConfigure.Header.Icon><IconInformation /></CardConfigure.Header.Icon>
						<CardConfigure.Header.Title>Filter</CardConfigure.Header.Title>
						<CardConfigure.Header.Close onClick={() => {
							filterHide()
						}}>
							<IconClose />
						</CardConfigure.Header.Close>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="audit-trail__content">
								<div className="audit-trail__content__row">
									<div className="audit-trail__content__left">
										Date
									</div>
									<div className="audit-trail__content__right">
										<DatePicker
											selected={startDate}
											onChange={onDateChange}
											startDate={startDate}
											endDate={endDate}
											selectsRange={true}
											isClearable
											placeholderText="Select Date From - Date To"
										/>
									</div>
								</div>
								<div className="audit-trail__content__row">
									<div className="audit-trail__content__left">
										Type
									</div>
									<div className="audit-trail__content__right">
										<Select selectProps={{ onChange: (e)=>handleSelectTypeChange(e),
										 value: selectTypeValue || "Select"
										}}>
											<option disabled value='Select'>Select</option>
											{
												selectTypeOptions?.map((option, index)=>{
													return <option key={index} value={option.id}>{option.name}</option>
												})
											}
										</Select>
									</div>
								</div>
								{selectTypeValue === "DATA_EXCHANGE" &&
									<>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Event
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={selectedDataEventValues} onChangeFunc={setSelectedDataEventValues} />
											</div>
										</div>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Destination
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={participantsOptions} onChangeFunc={setParticipantsOptions} />
											</div>
										</div>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Via
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={selectedViaValues} onChangeFunc={setSelectedViaValues} />
											</div>
										</div>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Data Element
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={dataElementsOptions} onChangeFunc={setDataElementsOptions} />
											</div>
										</div>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Status
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={selectedStatusValues} onChangeFunc={setSelectedStatusValues} />
											</div>
										</div>
									</>
								}
								{selectTypeValue === "USER_ACTIVITY" &&
									<>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Event
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={selectedUserEventValues} onChangeFunc={setSelectedUserEventValues} />
											</div>
										</div>
										<div className="audit-trail__content__row">
											<div className="audit-trail__content__left">
												Status
											</div>
											<div className="audit-trail__content__right">
												<MultiSelectCheckbox items={selectedStatusValues} onChangeFunc={setSelectedStatusValues} />
											</div>
										</div>
									</>
								}

							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button ghost text={t("reset")} submit={() => { handleReset() }} />
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button text={t("submit")} submit={() => { handleSubmit() }} />
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal> */}

			<Modal visible={detailVisible} variant='large' close={detailHide}>
				<KeyboardEventHandler handleKeys={["esc"]} onKeyEvent={(_key, _e) => {
					detailHide()
				}} />
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left" data-testid="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={''}>
											<div className='DS__icon--theme'>
											<IconInformation />
											</div>
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Detail
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="audit-trail-container">
								<div className='audit-trail-container--left audit-trail-container--layout'>
									<div>User</div>
									<div>Event</div>
									<div>Message</div>
									{currentAudit?.data?.participants && <div>Sender / Destination</div>}
									{currentAudit?.data?.elementName && <div>Data Element</div>}
									<div>Via</div>
									<div>Status</div>
									<div>Date</div>
									{
										currentAudit?.related && (
											<>
												<div>User</div>
												<div>Event</div>
												<div>Message</div>
												{currentAudit?.data?.participants && <div>Sender / Destination</div>}
												{currentAudit?.data?.elementName && <div>Data Element</div>}
												<div>Via</div>
												<div>Status</div>
												<div>Date</div>
											</>

										)
									}
								</div>
								<div className='audit-trail-container--right'>
									{currentAudit && <AuditLogEntry audit={currentAudit} />}
									{currentAudit?.related && <AuditLogEntry audit={currentAudit.related} />}
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button text="Close" submit={() => {
								detailHide()
								setAudit(null)
							}}>Close</Button>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{
				loading && (
					ReactDOM.createPortal(
						<div className='modal white'>
							<div className='loading'>
								<img src="/loading.gif" />
							</div>
						</div>
						, document.body
					)
				)
			}
			<Toast2 show={error} errorMessage={error} close={() => { handleError() }} />
		</>
	)
}

export default Page
